import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        forms: '=',
        company: '='
    },
    template: `
        <div class="heading01 type01"><h1>{{ 'evaluationGroup.Create 360 group' | translate }}</h1></div>
        <form ng-submit="vm.import()" class="form" enctype="multipart/form-data">
            <form-wrapper form="vm.form">
                <evaluation-form form="vm.form" company="vm.company" forms="vm.forms"/>
                <form-row error="vm.form.errors.file" ng-if="!vm.form.model.id">
                    <label class="label">{{ 'general.File' | translate }}</label>
                    <div class="items">
                        <input ngf-select="vm.setFile($file)" ng-model="vm.form.model.file" type="file">
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <div class="row has-error" ng-if="vm.form.errors.excel">
                    <label class="label">{{ 'evaluationGroup.Excel errors' | translate }} *</label>
                    <div class="items">
                        <p ng-repeat="(rowIndex, errors) in vm.form.errors.excel"
                        ng-bind-html="vm.getExcelRowErrors(rowIndex, errors)"></p>
                    </div>
                </div>
                <ul class="actions01">
                    <li class="primary">
                        <button ng-if="!vm.importInProgress" type="submit" class="btn main">{{ 'general.Create' | translate }}</button>
                    </li>
                    <li><a ui-sref="authorized.evaluation.list()" class="btn discrete" >{{ 'general.Cancel' | translate }}</a></li>
                </ul>
            </form-wrapper>
        </form>
        <div ng-if="vm.importInProgress" class="alert alert-success">
          {{ (vm.form.model.file ? 'general.Import is in progress': 'general.Saving') | translate }}
        </div>
    `
})
export default class {
    constructor ($state, $translate, lodash, Upload) {
        this.$state = $state;
        this.$translate = $translate;
        this.lodash = lodash;
        this.Upload = Upload;
    }

    $onInit () {
        this.importInProgress = false;
        this.form = {
            model: {}
        };
    }

    import () {
        const url = `${SEED_CORE.ENV.API_URL}evaluation/evaluation-group/import`;
        this.importInProgress = true;
        this.Upload
            .upload({ url, data: this.form.model })
            .then((evaluationGroup) => {
                this.$state.go('authorized.evaluation.view', { id: evaluationGroup.data.id });
            }).catch((response) => {
                this.importInProgress = false;
                this.form.invalid = true;
                this.form.saved = false;
                this.form.errors = {};
                this.form.errors = response.data.reduce((original, error) => {
                    original[error.field] = error.message;
                    return original;
                }, {});
            });
    }

    setFile (file) {
        this.form.model.file = file;
    }

    getExcelRowErrors (row, errors) {
        const columnMessages = [];
        this.lodash.forEach(errors, (message, column) => {
            columnMessages.push(this.$translate.instant('evaluationGroup.Row {row} Column {column} : {message}',
                { row, column, message }
            ));
        });
        return columnMessages.join('<br>');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/import/index.js